import(/* webpackMode: "eager" */ "C:\\react\\lakeeshop\\src\\app\\error.tsx");
